/**
 * Format a vanilla-jsoneditor `Content` value (`{json: value}` in tree/table
 * mode, or `{text: string}` in code/text mode) for storage in the hidden
 * textarea backing the form field.
 */
export function contentToText(content) {
  return 'text' in content ? content.text : JSON.stringify(content.json);
}
